import React, { useState, useEffect } from 'react';
import { Card, Typography, Button } from 'antd';
import { 
  BookOutlined,
  PlusOutlined,
  FileTextOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import blogData from '../../utils/blogData';
import './index.css';

const { Title, Text } = Typography;

const Home = () => {
  const [stats, setStats] = useState({
    totalPosts: 0,
    archiveCount: 0
  });

  useEffect(() => {
    loadStats();
    
    // 监听数据更新
    window.addEventListener('blogDataUpdated', loadStats);
    
    return () => {
      window.removeEventListener('blogDataUpdated', loadStats);
    };
  }, []);

  const loadStats = () => {
    const allStats = blogData.getStats();
    setStats({
      totalPosts: allStats.totalPosts,
      archiveCount: allStats.archiveCount
    });
  };

  return (
    <div className="home-page">
      {/* 顶部横幅 */}
      <div className="hero-banner">
        <div className="banner-content">
          <h1 className="site-title">我的技术博客</h1>
          <p className="site-subtitle">专注于技术分享与学习</p>
          
          <div className="quick-stats">
            <div className="stat-item">
              <FileTextOutlined className="stat-icon" />
              <div className="stat-content">
                <Text strong className="stat-number">{stats.totalPosts}</Text>
                <Text type="secondary">篇文章</Text>
              </div>
            </div>
            <div className="stat-item">
              <BookOutlined className="stat-icon" />
              <div className="stat-content">
                <Text strong className="stat-number">{stats.archiveCount}</Text>
                <Text type="secondary">个归档月份</Text>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 快速操作 */}
      <div className="quick-actions">
        <Card className="action-card">
          <div className="action-content">
            <Title level={4}>开始写作</Title>
            <Text type="secondary">记录你的想法和技术经验</Text>
            <div style={{ marginTop: 20 }}>
              <Link to="/write">
                <Button type="primary" icon={<PlusOutlined />} size="large">
                  写新文章
                </Button>
              </Link>
            </div>
          </div>
        </Card>
        
        <Card className="action-card">
          <div className="action-content">
            <Title level={4}>查看归档</Title>
            <Text type="secondary">按时间线浏览所有文章</Text>
            <div style={{ marginTop: 20 }}>
              <Link to="/archive">
                <Button type="default" icon={<BookOutlined />} size="large">
                  浏览归档
                </Button>
              </Link>
            </div>
          </div>
        </Card>
      </div>

      {/* 温馨提示 */}
      <Card className="tip-card">
        <div className="tip-content">
          <Title level={5}>💡 使用提示</Title>
          <ul className="tip-list">
            <li>点击"写新文章"开始创作</li>
            <li>文章会自动保存到本地存储</li>
            <li>归档页面会实时显示文章统计</li>
            <li>数据保存在浏览器本地，清空浏览器数据会丢失</li>
          </ul>
        </div>
      </Card>
    </div>
  );
};

export default Home;